import type * as React from 'react'

import { styled } from 'styled-components'

import { ErrorBoundary } from '@b-stock/fe-core/bstock-react'

import { PageWidth } from '@/components/PageWidth'
import { useLogError } from '@/helpers/useLogError'

import { Footer } from '../shared/Footer'
import { Header } from '../shared/Header'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Body = styled(PageWidth)`
  display: flow-root; // contain child margins
`

export const CardLayout = ({ children }: { children: React.ReactNode }) => {
  const logError = useLogError()

  return (
    <Container>
      <Header />

      <ErrorBoundary onError={logError}>
        <Body>{children}</Body>
      </ErrorBoundary>

      <Footer />
    </Container>
  )
}
